import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createBackupManagerQuery,
  deleteBackupManagerQuery,
  getBackupManagerByIdQuery,
  getBackupManagerListQuery,
  updateBackupManagerQuery,
} from "./queries";
const BackupManagerContext = createContext({});

export const useBackupManagerContext = () => useContext(BackupManagerContext);

export const BackupManagerProvider = ({ ...props }) => {
  const [backupManagerList, setBackupManagerList] = useState([]);
  const [backupManagerPerId, setBackupManagerPerId] = useState({});

  const getBackupManagerList = useCallback(async () => {
    try {
      if (backupManagerList?.length === 0) {
        setBackupManagerList(await getBackupManagerListQuery());
      }
    } catch (e) {
      console.error("getBackupManagerList", e);
      throw e;
    }
  }, [backupManagerList]);

  const getBackupManagerById = useCallback(
    async (id) => {
      try {
        setBackupManagerPerId(await getBackupManagerByIdQuery(id));
      } catch (e) {
        console.error("getBackupById", e);
        throw e;
      }
    },
    [setBackupManagerPerId]
  );

  const createBackupManager = useCallback(async (data) => {
    try {
      const result = await createBackupManagerQuery(data);
      setBackupManagerList((old) => [...old, result]);
    } catch (e) {
      console.error("createBackup", e);
      throw e;
    }
  }, []);

  const updateBackupManager = useCallback(async (id, data) => {
    try {
      const result = await updateBackupManagerQuery(id, data);
      setBackupManagerPerId(result);
      setBackupManagerList((old) =>
        old.map((elm) => (elm.id === result.id ? result : elm))
      );
    } catch (e) {
      console.error("updateBackupById", e);
      throw e;
    }
  }, []);

  const deleteBackupManager = useCallback(
    async (id) => {
      try {
        await deleteBackupManagerQuery(id);
        setBackupManagerList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("deleteBackup", e);
        throw e;
      }
    },
    [setBackupManagerList]
  );

  const values = useMemo(
    () => ({
      backupManagerList,
      getBackupManagerList,
      getBackupManagerById,
      deleteBackupManager,
      createBackupManager,
      updateBackupManager,
      backupManagerPerId,
      setBackupManagerPerId,
    }),
    [
      backupManagerList,
      getBackupManagerList,
      getBackupManagerById,
      deleteBackupManager,
      createBackupManager,
      updateBackupManager,
      backupManagerPerId,
      setBackupManagerPerId,
    ]
  );
  return <BackupManagerContext.Provider value={values} {...props} />;
};
